// extracted by mini-css-extract-plugin
export var dropdown = "_u3-0";
export var imageWrapper = "_u3-3";
export var itemNameContainer = "_u3-1";
export var productImage = "_u3-2";
export var spinnerWrapper = "_u3-4";